// One reactive count of what has been posted in 소통방 since this device last
// looked (Eddie 2026-09-16). Fed by roomActivityService.watchFresh; cleared by
// markRoomSeen when the room is opened. The tab bar's badge reads it.
import { reactive } from 'vue';

export const roomStore = reactive({ fresh: 0 });
export default roomStore;
